import { render, staticRenderFns } from "./trainTrendRank.vue?vue&type=template&id=81a1bc60&scoped=true"
import script from "./trainTrendRank.vue?vue&type=script&lang=js"
export * from "./trainTrendRank.vue?vue&type=script&lang=js"
import style0 from "./trainTrendRank.vue?vue&type=style&index=0&id=81a1bc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a1bc60",
  null
  
)

export default component.exports